var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",class:_vm.dynamicClass},[_vm._v("\n  "+_vm._s(_vm.formattedContent)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }